import { LayoutContext, LayoutContextProps } from '@/utils/providers/layoutContext/LayoutContext';
import React, { PropsWithChildren, useMemo, useState } from 'react';

export const LayoutProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [fullScreenVideo, setFullScreenVideo] = useState(false);
  const [headerSlot, setHeaderSlot] = useState<HTMLElement | null>(null);

  const context: LayoutContextProps = useMemo(() => {
    return {
      fullScreenVideo,
      headerSlot,
      setFullScreenVideo,
      setHeaderSlot,
    };
  }, [fullScreenVideo, headerSlot]);

  return <LayoutContext.Provider value={context}>{children}</LayoutContext.Provider>;
};
